export default {
    props: {
        checkboxesCheckChildren: {
            type: Boolean,
            default: undefined,
            kComposite: 'checkboxes.checkChildren'
        }, 
        checkboxesName: {
            type: String,
            default: undefined,
            kComposite: 'checkboxes.name'
        }, 
        checkboxesTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'checkboxes.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/Checkboxes.js